import { pb } from '@/core/api';
import { getFingerprint } from '@/utils/fingerprint';

export type AccessDecision = 'ok' | 'account_banned' | 'ip_banned';

export type AccessResponse = {
  access: AccessDecision;
  reason?: string;
  expires_at?: string | null;
  has_pending_funds: boolean;
  has_wallet: boolean;
  redemption_active?: boolean;
};

const TTL_MS = 30_000;
let cache: { value: AccessResponse; ts: number } | null = null;
let inflight: Promise<AccessResponse> | null = null;

export function invalidateAccessCache(): void {
  cache = null;
  inflight = null;
}

export async function checkAccess(): Promise<AccessResponse> {
  const now = Date.now();
  if (cache && now - cache.ts < TTL_MS) return cache.value;
  if (inflight) return inflight;
  inflight = (async () => {
    const fp = await getFingerprint();
    const res: AccessResponse = await pb.send('/api/auth/check-access', {
      method: 'POST',
      body: { fingerprint: fp },
    });
    cache = { value: res, ts: Date.now() };
    inflight = null;
    return res;
  })();
  return inflight;
}
